import { fetchBaseQuery } from "@reduxjs/toolkit/query";

const customBaseQuery = fetchBaseQuery({
  baseUrl: "https://gateway.handychat.io",
  credentials: "include", // Tüm isteklerde çerezleri gönder
  prepareHeaders: (headers) => {

    headers.set("Accept", "application/json");
    return headers;
  },
});

export default customBaseQuery;